<template>
  <a-col :md="grid" :sm="24" class="search-col">
    <span class="search-buttons">
      <a-button
        :disabled="queryFuncName !== '' && checkOperateDisable(queryFuncName)"
        :loading="crud.loading"
        type="primary"
        @click="toDiyQuery"
        >查询</a-button
      >
      <a-button
        v-if="crud.optShow.reset"
        :disabled="queryFuncName !== '' && checkOperateDisable(queryFuncName)"
        style="margin-left: 8px"
        @click="toDiyResetQuery"
        >重置</a-button
      >
    </span>
  </a-col>
</template>
<script>
import { crud } from "@crud/crud"
import store from "@/store"
import {
  checkMultiTypeOperateDisable,
  checkOperateDisable
} from "@/router/permission"

export default {
  mixins: [crud()],
  props: {
    grid: {
      type: Number,
      default() {
        return 4
      }
    },
    queryFuncName: {
      type: String,
      default() {
        return ""
      }
    }
  },
  data() {
    return {
      store
    }
  },
  created() {},
  methods: {
    checkMultiTypeOperateDisable,
    checkOperateDisable,
    toDiyQuery() {
      let _this = this
      if (_this.$listeners["toDiyQuery"]) {
        _this.$emit("toDiyQuery")
      } else {
        this.crud.toQuery()
      }
    },
    toDiyResetQuery() {
      let _this = this
      if (_this.$listeners["toDiyResetQuery"]) {
        _this.$emit("toDiyResetQuery")
      } else {
        this.crud.resetQuery()
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.search-col {
  display: flex;
  align-items: flex-start;
  justify-content: flex-end;
}

.search-buttons {
  display: inline-flex;
  align-items: center;
  white-space: nowrap;
  line-height: 28px;
  font-size: 12px;
}
</style>
